<template>
  <i-drawer
    :visible="isShowable"
    class="credit-faq-modal"
    title="Credit Confidence Score"
    subtitle="This signifies Inscribe's confidence in the accuracy of the credit
            insights"
    @hide-drawer="closeDrawer"
  >
    <credit-confidence-score-slider />

    <h5
      class="i-text-heading-5 i-text-neutral-120 i-mt-15 i-mb-10"
      abbr="Frequently Asked Questions"
    >
      FAQs
    </h5>
    <i-accordion>
      <i-accordion-item title="What is the Confidence Score?">
        <p class="i-mt-0 i-mb-sm i-text-neutral-110 i-text-body-3">
          The Confidence Score represents the degree of certainty for the
          accuracy of the Inscribe Credit Insights. It is a float bounded
          between 0 and 1, with higher Confidence Scores representing higher
          certainty.
        </p>
        <a :href="linkAddress" class="i-link i-text-body-3" target="_blank"
          >Learn more</a
        >
      </i-accordion-item>
      <i-accordion-item title="How is the Confidence Score calculated?">
        <p class="i-mt-0 i-mb-sm i-text-neutral-110 i-text-body-3">
          The Confidence Score represents the degree of certainty for the
          accuracy of the Inscribe Credit Insights. This accuracy is highly
          affected by the performance of the proprietary parsing and
          categorization models. Thus, the Confidence Score is calculated as a
          weighted combination of the parsing and categorization performance for
          all submitted customer documents and open banking data.
        </p>
        <p class="i-mt-0 i-mb-sm i-text-neutral-110 i-text-body-3">
          For information about what can affect the Confidence Score, see the
          section below.
        </p>
        <a :href="linkAddress" class="i-link i-text-body-3" target="_blank"
          >Learn more</a
        >
      </i-accordion-item>
      <i-accordion-item title="What affects the Confidence Score?">
        <p class="i-mt-0 i-mb-sm i-text-neutral-110 i-text-body-3">
          The Confidence Score is calculated as a weighted combination of the
          parsing and categorization performance. The parsing performance (and
          therefore the Confidence Score) is likely to be negatively affected
          if:
        </p>
        <ul
          class="i-mt-0 i-mb-sm i-text-neutral-110 i-text-body-3 i-p-none i-pl-xl"
        >
          <li class="i-mb-2">The submitted document(s) are not true PDFs</li>
          <li class="i-mb-2">
            The submitted document(s) have been stitched together (i.e. each
            document is a merged PDF of other PDFs and/or images)
          </li>
          <li class="i-mb-2">The submitted document(s) are missing pages</li>
        </ul>
      </i-accordion-item>
      <i-accordion-item
        title="How does the Confidence Score differ from the Trust Score?"
      >
        <p class="i-mt-0 i-mb-sm i-text-neutral-110 i-text-body-3">
          <strong>Trust Score:</strong> A document's Trust Score indicates how
          likely it is to be fraudulent. A higher score indicates the document
          is less likely to be fraudulent, while a lower score suggests it may
          be fraudulent.
        </p>
        <p class="i-mt-0 i-mb-sm i-text-neutral-110 i-text-body-3">
          <strong>Confidence Score:</strong> The Confidence Score represents the
          degree of certainty for the accuracy of the Inscribe Credit Insights.
          It is calculated across all submitted documents and open banking data
          for a customer. It is a float bounded between 0 and 1, with higher
          Confidence Scores representing higher certainty..
        </p>
        <a :href="linkAddress" class="i-link i-text-body-3" target="_blank"
          >Learn more</a
        >
      </i-accordion-item>
    </i-accordion>

    <template #footer>
      <i-button
        data-testid="got-it-button"
        text="Got it"
        class="w-100"
        subtype="outline"
        size="lg"
        @button-click="closeDrawer"
      ></i-button>
    </template>
  </i-drawer>
</template>

<script>
import { iButton, iDrawer, iAccordion, iAccordionItem } from '@inscribe/signal';
import CreditConfidenceScoreSlider from './CreditConfidenceScoreSlider';

export default {
  components: {
    iButton,
    iDrawer,
    iAccordion,
    iAccordionItem,
    CreditConfidenceScoreSlider,
  },
  props: {
    isShowable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      linkAddress:
        'https://docs.inscribe.ai/docs/what-does-the-confidence-score-mean',
    };
  },
  methods: {
    closeDrawer() {
      this.$emit('hide-faq-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
.credit-faq-modal {
  background: inherit;
  &__header {
    width: 85%;
  }
}
</style>
